var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoChampOligatoire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 34,
    viewBox: "0 0 20 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "*",
    fill: "#e84470",
    fontSize: 23,
    fontFamily: "NotoSansJP-Medium, Noto Sans JP",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "*"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoChampOligatoire);
export default __webpack_public_path__ + "static/media/Picto-champ-oligatoire.1911b948dac6daca9cffa4cdc3592516.svg";
export { ForwardRef as ReactComponent };